import React, { useState } from 'react';
import logo from '../../../assets/images/brandlogo.png'
import publisherStyle from './PublishersLoginPage.module.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaUserLarge } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { Link } from 'react-router-dom';
require('typeface-poppins')

export default function PublishersLoginPage() {

    // Eye	
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!isPasswordVisible);
    };

    return (
        <>
            <div className={publisherStyle.publishercationMain}>
                <div className="container h-100">
                    <div className="row justify-content-center h-100 align-items-center">
                        <div className="col-md-6">
                            <div className={publisherStyle.publishercationContent}>
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className={publisherStyle.publisherForm}>
                                            <div className="text-center mb-3">
                                                <a href="#" className={publisherStyle.publisherbrandLink}>
                                                    <img src={logo} alt="BrandLogo" />
                                                    <div className={publisherStyle.publisherbrandInfo}>
                                                        <span> AuthorMeet </span>
                                                        <small> Powered by: &nbsp; Bookworm Central </small>
                                                    </div>
                                                </a>
                                            </div>
                                            <h4 className={publisherStyle.publisherbrandTitle}> Publishers Sign-in </h4>
                                            <form>
                                                <div className={`${publisherStyle.publisherinputIconboxes} input-group mb-4`}>
                                                    <span className={`${publisherStyle.publisherinputIcon} input-group-text`}>
                                                        <FaUserLarge className={publisherStyle.publisherprimaryColor} />
                                                    </span>
                                                    <input type="email" className={`${publisherStyle.publisherinputFeild} form-control`} placeholder="Email Address" required />
                                                </div>
                                                <div className={`${publisherStyle.publisherinputIconboxes} input-group mb-3`}>
                                                    <span className={`${publisherStyle.publisherinputIcon} input-group-text`}>
                                                        <FaLock className={publisherStyle.publisherprimaryColor} />
                                                    </span>
                                                    <input type={isPasswordVisible ? "text" : "password"} className={`${publisherStyle.publisherinputFeild} form-control`} placeholder="Password" required />
                                                    <div className={publisherStyle.publishertoggleButton} onClick={togglePasswordVisibility}>
                                                        {isPasswordVisible ? <FaEyeSlash className={publisherStyle.publishereyeIcon} /> : <FaEye className={publisherStyle.publishereyeIcon} />}
                                                    </div>
                                                </div>
                                                <div className={`${publisherStyle.publisherforgotPassword} form-group text-center mb-3`}>
                                                    <a href="#"> Forgot Password? </a>
                                                </div>
                                                <div className="form-row d-flex justify-content-between mt-3 mb-3 d-none d-lg-block">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-checkbox ml-1">
                                                            <input type="checkbox" className="custom-control-input me-2" id="" />
                                                            <label className={`${publisherStyle.publisherrememberMe} custom-control-label`}> Remember me </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`${publisherStyle.publishernewAccount} ${publisherStyle.mobilnewAccount} mb-4 mt-5`}>
                                                    <p className='mb-0'> Create new account? <Link to="/PublishersRegisterPage"> Sign Up </Link></p>
                                                </div>
                                                <div className="text-center">
                                                    <p style={{ color: 'red' }}></p>
                                                    <button type="submit" className={`${publisherStyle.publisherSigninBtn} btn btn-warning`}>Login</button>
                                                </div>
                                            </form>
                                            <div className={`${publisherStyle.publishernewAccount} ${publisherStyle.desktoppublishernewAccount}`}>
                                                <p className='mb-0'> Create new account?
                                                    <Link to="/PublishersRegisterPage"> Sign Up </Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
